import { Switch } from '@innovationdepartment/proxima-ui';

type BrandIsManagedViewProps = {
  isManaged?: boolean;
  onChange?: (isManaged: boolean) => void;
};

const BrandIsManagedView = ({ isManaged, onChange }: BrandIsManagedViewProps) => (
  <Switch checked={!!isManaged} onChange={onChange} />
);

export default BrandIsManagedView;
